// GlobalSocketHandler.jsx
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSocket } from "@/socketprovider";

export default function GlobalSocketHandler() {
  const socket = useSocket();
  const navigate = useNavigate();
  const lastSourceRef = useRef(null);

  useEffect(() => {
    if (!socket){
      console.log('❌ No socket connection available');
      return;
    }
    console.log(socket,"dd")
    const handleNewData = (newData) => {
     
      console.log("🔁 Global Socket Received:", newData);
      const partner = localStorage.getItem("partnerIdentifier");
      const userIdentifier = localStorage.getItem("user_identifier");

      const source = newData?.data?.source;
      const status = newData?.data?.status;

      if (!source || source === lastSourceRef.current) return;
      lastSourceRef.current = source;

      let nextRoute = null;

      if (source === "kyc") {
        if (newData?.data?.action === "redirect" && newData?.data?.sessionUrl) {
          console.log("➡️ KYC redirect to Digio:", newData.data.sessionUrl);
          window.location.href = newData.data.sessionUrl;
        } else if (newData?.data?.status === "waiting") {
          alert(newData?.data?.message || "Your KYC is under review. We will update you shortly.");
        }
        return;
      } else if (source === "banking") {
        nextRoute =
          status === "success"
            ? `/b/${userIdentifier}?partner=${partner}&step=congrats`
            : `/b/${userIdentifier}?partner=${partner}&step=banking-sorry`;

            console.log("➡️ Navigating to:", nextRoute);
      } else if (source === "esign") {
        nextRoute = `/b/${userIdentifier}?partner=${partner}&step=mandate`;
      } else if (source === "rent") {
        nextRoute = `/b/${userIdentifier}?partner=${partner}&step=happy-move-in`;
      } else if (newData?.data?.navigate) {
        nextRoute = `/b/${userIdentifier}?partner=${partner}&step=${newData.data.navigate}`;
      }

      if (nextRoute) {
        console.log("➡️ Navigating to:", nextRoute);
        navigate(nextRoute);
        window.location.replace(nextRoute);
      }
    };

 socket.on("joined", (response) => {
        console.log("Joined room:", response);
      });


    socket.on("newData", handleNewData);
    return () => socket.off("newData", handleNewData);
  }, [socket, navigate]);

  return null;
}
